import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { 
  Box, 
  Button, 
  Heading, 
  Badge,
  IconButton,
  Loader
} from 'monday-ui-react-core';
import { 
  Edit, 
  Delete, 
  Download, 
  Send 
} from 'monday-ui-react-core/icons';
import waveClient from '../../services/wave/waveClient';
import { formatCurrency, formatDate } from '../../utils/formatters';
import Loading from '../common/Loading';

const InvoiceDetails = ({ invoice, onEdit, onBack }) => {
  return (
    <Box className="invoice-details">
      <h2>Invoice #{invoice.invoiceNumber}</h2>
      <Box className="invoice-status">
        Status: {invoice.status}
      </Box>
      <Box className="invoice-info">
        {/* Invoice details */}
      </Box>
      <Box className="actions">
        <Button onClick={onEdit}>Edit Invoice</Button>
        <Button onClick={onBack}>Back to List</Button>
      </Box>
    </Box>
  );
};

export default InvoiceDetails; 